var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.accountId)?_c('p',{staticClass:"subtitle is-size-6"},[_c('span',[_vm._v(_vm._s(_vm.$t('general.balance'))+": ")]),_vm._v(" "),_c(_setup.Money,{attrs:{"value":_setup.realBalance,"inline":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }